import { AnimatedFigcaption } from 'components/animated-figcaption'
import { Container, TextContainer } from 'components/container'
import { Title } from 'components/misc'
import GoldenTexture from 'assets/golden-bg.webp'
import FlowerImage from './assets/Flower_Marya.png'
import { Caption, Svg } from './styled'

//  <circle cx="311" cy="438" r="311" fill="#F0BAC6" fill-opacity="0.75" />

export const FlowerLarge = () => (
  <>
  <TextContainer>
    <Title>Марьямоль</Title>
    </TextContainer>
    <AnimatedFigcaption
      FigCaptionComponent={Caption}
      description={
        <p>
          Национальный символ Коми – цветок марьямоль. Его еще называют марьин{' '}
          <br />
          корень или пион уклоняющийся. Настойка пиона уклоняющегося применяется
          в
          <br />
          народной медицине как седативное средство. Именно это цветок собирает
          <br />
          девушка в известной одноименной{' '}
          <a
            target="_blank"
            href="https://lyricstranslate.com/ru/%D0%BC%D0%B0%D1%80%D1%8A%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C-%D0%BC%D0%B0%D1%80%D1%8C%D1%8F%D0%BC%D0%BE%D0%BB%D1%8C.html"
            rel="noreferrer"
          >
            песне
          </a>
        </p>
      }
    />

    <Svg
      viewBox="0 100 622 752"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <pattern id="golden-texture-flower" width="100%" height="100%">
          <image href={GoldenTexture} width="1600" height="982" />
        </pattern>
      </defs>

      <circle cx="311" cy="438" r="311" fill="#F0BAC6" fill-opacity="0.75" />

      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M480.166 187.006C480.165 187.006 480.165 187.006 480.142 186.007C480.119 185.007 480.12 185.007 480.12 185.007L480.124 185.007L480.136 185.006L480.182 185.006C480.222 185.005 480.28 185.004 480.357 185.003C480.51 185.001 480.736 185 481.029 185C481.616 185.001 482.473 185.01 483.561 185.041C485.738 185.105 488.843 185.262 492.568 185.632C500.011 186.373 509.955 187.971 519.913 191.408C529.867 194.843 539.894 200.135 547.44 208.3C555.007 216.488 560.032 227.516 560.032 242.301C560.032 253.102 553.74 263.983 543.235 274.521C532.711 285.079 517.831 295.424 500.353 305.165C465.389 324.65 419.853 341.814 377.472 353.457C309.042 372.257 250.861 394.224 206.196 416.066C161.492 437.929 130.448 459.611 116.162 477.789C95.9932 503.446 83.581 535.496 76.5856 565.325C69.5896 595.156 68.0317 622.678 69.5086 639.22L67.5165 639.398C66.0174 622.606 67.6029 594.868 74.6384 564.868C81.6745 534.866 94.1817 502.514 114.589 476.553C129.169 458.001 160.562 436.157 205.318 414.27C250.113 392.363 308.414 370.355 376.942 351.529C419.218 339.914 464.594 322.803 499.379 303.418C516.775 293.723 531.478 283.483 541.818 273.109C552.178 262.717 558.032 252.32 558.032 242.301C558.032 228.019 553.196 217.476 545.971 209.658C538.725 201.818 529.03 196.67 519.261 193.298C509.497 189.929 499.718 188.353 492.37 187.622C488.698 187.257 485.64 187.103 483.503 187.041C482.434 187.009 481.596 187.001 481.027 187C480.742 187 480.525 187.001 480.38 187.003C480.307 187.004 480.253 187.005 480.217 187.005L480.177 187.006L480.168 187.006L480.166 187.006Z"
        fill="url('#golden-texture-flower')"
      />

      <g clip-path="url(#clip0_1331_523)">
        <path
          d="M466.629 174.624C466.629 174.624 545.519 172.783 545.519 230.918C545.519 272.56 448.351 317.852 363.694 341.11C226.737 378.737 130.729 429.057 101.863 465.788C61.2868 517.406 52.0239 594.593 54.9999 627.926"
          stroke="url(#flower-large-pattern0)"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </g>

      <text
        fill="#343431"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        font-family="Articulat CF"
        font-size="14"
        font-style="italic"
        letter-spacing="0em"
        x="28"
      >
        <tspan x="28" y="660.06">
          Визув юӧ петӧ ель, петӧ ель, петӧ ель,
        </tspan>
        <tspan x="28" y="680.06">
          Быдмӧ сэтӧн маръямоль, маръямоль, маръямоль…
        </tspan>
        <tspan x="28" y="700.06">
          &#xa0;&#10;
        </tspan>
        <tspan x="28" y="720.06">
          Маръямоль да маръямоль…
        </tspan>
        <tspan x="28" y="740.06">
          Маръямоль да маръямоль…
        </tspan>
        <tspan x="28" y="760.06">
          &#xa0;&#10;
        </tspan>
        <tspan x="28" y="780.06">
          Сикӧтш вылӧ куим-нёль, куим-нёль, куим-нёль,
        </tspan>
        <tspan x="28" y="800.06">
          Колӧ дзоридз маръямоль, маръямоль, маръямоль…
        </tspan>
      </text>
      <text
        fill="#343431"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        font-family="Articulat CF"
        font-size="14"
        font-style="italic"
        letter-spacing="0em"
      >
        <tspan x="397" y="660.06">
          На быструю речку выходит ручей
        </tspan>
        <tspan x="397" y="680.06">
          Растет там марьямоль....
        </tspan>
        <tspan x="397" y="700.06">
          &#xa0;&#10;
        </tspan>
        <tspan x="397" y="720.06">
          Марьямоль да марьямоль...
        </tspan>
        <tspan x="397" y="740.06">
          Марьямоль да марьямоль...
        </tspan>
        <tspan x="397" y="760.06">
          &#xa0;&#10;
        </tspan>
        <tspan x="397" y="780.06">
          Надо на бусы мне три-четыре
        </tspan>
        <tspan x="397" y="800.06">
          Этих цветков, марьямоль...
        </tspan>
      </text>
      <rect
        x="154"
        y="235"
        width="300"
        height="394"
        fill="url(#flower-large-pattern1)"
      />
      <defs>
        <pattern
          id="flower-large-pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <image
            width="415"
            height="800"
            xlinkHref=""
            transform="matrix(0 -0.00240964 0.00222452 0 -0.389807 1)"
          />
        </pattern>
        <pattern
          id="flower-large-pattern1"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <image
            width="3121"
            height="4096"
            xlinkHref={FlowerImage}
            transform="matrix(0.000320638 0 0 0.000244141 -0.000355632 0)"
          />
        </pattern>
        <clipPath id="clip0_1331_523">
          <rect
            width="492"
            height="454"
            fill="white"
            transform="translate(54 174)"
          />
        </clipPath>
      </defs>
    </Svg>
  </>
)
